/**
 * Whether this page load has already opened on its default view.
 *
 * **Module-level, not a `useRef`** — and the difference is a bug this component shipped
 * with. `queryKeys.layers(role)` is role-keyed, so the §F3 demo switcher (and any real
 * session change) swaps the query and re-runs everything downstream of it; a ref that lives
 * with the component is only as durable as the component, and the effect fired again on a
 * map the reader had already emptied, putting the land-cover default back over their own
 * choice. "The explorer opens on land cover" is a fact about the *page load*, which is the
 * scope `features/sidebar/paneSwitch.ts` already uses for the same kind of statement.
 */
let opened = false;

export function defaultViewOpened(): boolean {
  return opened;
}

export function markDefaultViewOpened(): void {
  opened = true;
}

/** Test helper — a fresh page load, with no default view applied yet. */
export function resetDefaultView(): void {
  opened = false;
}
